<template>
    <div class="app-container">
        <div class="header" :class="{ 'opaque': scrolled || forceOpaque || menuOpen }">
            <button class="menu-button hamburger hamburger--collapse" :class="{ 'is-active': menuOpen }" type="button"
                    v-on:click="toggleMenu()">
              <span class="hamburger-box">
                <span class="hamburger-inner"></span>
              </span>
            </button>

            <div class="title-logo">
                <img class="logo" :src="images.entelectLogo"/>
                <img class="logo-mini" :src="images.entelectLogoMini"/>

                <h1 class="title">Retrospectives 2018</h1>
                <h2 class="title-mini">Retrospectives '18</h2>
            </div>

            <div class="menu" :class="{ 'open': menuOpen }">
                <router-link class="menu-item" to="/" active-class="route-active" exact>
                    Foreword
                </router-link>
                <router-link class="menu-item" to="/technologies" active-class="route-active">
                    State of Technology
                </router-link>
                <router-link class="menu-item" to="/initiatives" active-class="route-active">
                    Initiatives
                </router-link>
                <router-link class="menu-item" to="/contributions" active-class="route-active">
                    Contributions
                </router-link>
                <router-link class="menu-item" to="/events" active-class="route-active">
                    Events
                </router-link>
            </div>
        </div>
        <div id="app-content">
            <router-view></router-view>
        </div>

        <div class="overlay" :class="{ 'open': menuOpen }" v-on:click="closeMenu()"></div>
    </div>
</template>

<script>
    import entelectLogoImage from '../assets/images/entelect-logo.png';
    import entelectLogoMiniImage from '../assets/images/entelect-logo-mini.png';

    export default {
        data: function () {

            return {
                images: {
                    entelectLogo: entelectLogoImage,
                    entelectLogoMini: entelectLogoMiniImage
                },
                menuOpen: false,
                scrolled: false,
                forceOpaque: this.$route.path !== '/'
            }
        },
        methods: {
            toggleMenu: function () {
                this.menuOpen = !this.menuOpen;
            },
            closeMenu: function () {
                this.menuOpen = false;
            },
            handleScroll: function () {
                const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                this.scrolled = scrollTop > 60;
            }
        },
        beforeRouteUpdate(to, from, next) {
            this.forceOpaque = to.path !== '/';

            this.closeMenu();
            next();
        },
        beforeMount() {
            window.addEventListener('scroll', this.handleScroll, true);
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll, true);
        }
    }
</script>

<style lang="scss" scoped>

    .app-container {
        display: grid;
        grid-template-columns: auto;
    }

    .header {
        position: fixed;
        top: 0;
        width: 100%;
        height: 60px;
        display: grid;
        background: transparent;
        transition: ease-in-out 300ms;
        transition-property: background-color, box-shadow;

        grid-template-columns: 450px 1fr;
        align-content: center;
        justify-content: center;
        color: white;
        z-index: 100;

        &.opaque {
            background: $dark-blue;
            box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
        }

        .menu-button {
            display: none;
        }

        .title-logo {
            display: grid;
            grid-auto-flow: column;
            align-content: center;
            justify-content: center;
            align-self: start;
            justify-self: center;
            height: 100%;

            .logo-mini,
            .logo {
                height: 36px;
                align-self: center;
                justify-self: center;
            }

            .logo-mini {
                display: none;
            }

            .title-mini,
            .title {
                padding-left: 12px;
            }

            .title-mini {
                display: none;
            }
        }

        .menu {
            display: grid;
            grid-auto-columns: 1fr;
            grid-auto-rows: 40px;
            grid-auto-flow: column;
            align-content: center;
            justify-content: center;

            .menu-item {
                display: grid;
                align-content: center;
                justify-content: center;
                text-align: center;
                height: 100%;
                font-size: 16px;
                color: white;
                text-decoration: none;
                transition: 0.25s all ease-in-out;

                &:hover {
                    &:not(.route-active) {
                        color: $entelect-orange;
                    }
                }

                &.route-active {
                    color: $green;
                }
            }
        }
    }

    .overlay {
        display: none;
    }

    #app-content {
        padding-top: 60px;
    }

    @media only screen and (max-width: $screen-md-max) {
        .header {
            grid-template-columns: 250px 1fr;

            .title-logo {

                .logo {
                    display: none;
                }

                .logo-mini {
                    display: initial;
                }

                .title {
                    display: none;
                }

                .title-mini {
                    display: grid;
                    align-items: center;
                    justify-items: center;
                }
            }
        }
    }

    @media only screen and (max-width: $screen-sm-max) {
        .app-container {
            grid-template-rows: 60px 1fr;
        }

        .header {
            grid-template-columns: 60px 1fr 60px;

            .menu-button {
                display: initial;
                height: 48px;
                background: transparent;
                border: none;
                outline: none !important;
            }

            .title-logo {
                .logo-mini {
                    height: 32px;
                }

                .title-mini {
                    font-size: 1.17em;
                }
            }

            .menu {
                grid-auto-flow: row;
                grid-auto-rows: 60px;
                align-content: start;
                justify-content: center;
                position: fixed;
                opacity: 0;
                top: 60px;
                bottom: 0;
                width: 320px;
                left: -320px;
                transition: 150ms linear;
                transition-property: left, background-color, opacity;
                z-index: 50;
                border-top: 1px solid #FFFFFF;
                box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .5), 0 2px 2px 0 rgba(0, 0, 0, .32), 0 1px 5px 0 rgba(0, 0, 0, .2);

                .menu-item {
                    padding: 0 24px;
                    align-content: center;
                    justify-content: start;
                    border-bottom: 1px solid #FFFFFF;

                    &:not(:last-child) {
                        border-right-width: 0;
                    }
                }

                &.open {
                    left: 0;
                    opacity: 1;
                    background-color: $dark-blue;
                }
            }
        }

        .overlay {
            display: block;
            position: fixed;
            top: 60px;
            bottom: 0;
            right: 0;
            left: 100%;
            background-color: rgba(0, 0, 0, 0.52);
            transition: left 150ms linear;
            z-index: 50;

            &.open {
                left: 320px;
            }
        }
    }

    @media only screen and (max-width: $screen-xs-max) {
        .header {
            .menu {
                grid-auto-flow: row;
                width: 100%;
                left: -100%;
            }
        }

        .overlay {
            display: none;
        }
    }

</style>
